import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { SettingsService } from '../../../core/settings/settings.service';
import { CoursModel } from '../../../cours/models/cours.model';
import { jourOptions, jourTransform } from '../../resource/select-options-static';
import { DateHelper } from '../../helpers/date.helper';
import { Subscription } from 'rxjs/Subscription';
import { FormGeneratorService, StoreService, TableMode } from '@ngx-resource-toolkit/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CoursActions } from '../../../cours/models/cours.store';
import { HttpClient } from '@angular/common/http';
import { InscriptionModel } from '../../inscriptions/inscription.model';
import { ToasterService } from 'angular2-toaster';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { environment } from '../../../../environments/environment';
import { TabsService } from '../../services/tabs.service';
import { ErrorMessageService } from '../../services/error-message.service';
import { ExportService } from '../../services/export.service';
import { CoursRechercheModel } from '../../../cours/models/cours-recherche.model';
import { SelectionType } from '@swimlane/ngx-datatable';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-cours-show',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class ShowCoursComponent implements OnInit, OnDestroy, OnChanges {
  private subParametres: any;
  private parametreSalle: Object;
  private parametreProfesseur: Object;

  @Input() coursId: number = undefined;
  @Input() showActions: boolean = true;
  @Output() coursModified: EventEmitter<any> = new EventEmitter<any>();

  cours: CoursModel;

  TableMode = TableMode;
  SelectionType = SelectionType;
  public anneesScolaires: Array<any> = [];
  public anneeScolaireDuCoursLibelle = '';
  inscription: InscriptionModel;
  form: FormGroup;
  public searchForm: FormGroup;
  public parametresRechercheInit: Object;
  public selectedEleves: Array<any> = [];
  public coursCible: any; // Cours cible pour le transfert d'élèves
  inscriptionsButtons = [];
  coursRechercheModel: CoursRechercheModel = new CoursRechercheModel();

  storeSubOptions: Subscription;
  storeSub: Subscription;
  paramMapSub: Subscription;

  loading: boolean = false;
  erreur: string = null;

  constructor(
    private http: HttpClient,
    private settings: SettingsService,
    private store: StoreService,
    private route: ActivatedRoute,
    private toaster: ToasterService,
    private formGenerator: FormGeneratorService,
    private tabsService: TabsService,
    private router: Router,
    private errorMessages: ErrorMessageService,
    private exportService: ExportService,
    private fb: FormBuilder,
  ) {
    if (!this.cours) {
      this.cours = new CoursModel();
    }
    this.inscription = new InscriptionModel();
  }

  @ViewChild('modalTransfert') modalTransfert: any;
  @ViewChild('modalConfirmationDelete') modalConfirmationDelete: any;
  confMessage: string = null;
  @ViewChild('modalConfirmationTransfert') modalConfirmationTransfert: any;
  @ViewChild('modalModifHoraires') modalModifHoraires: any;
  public jourOptions: any[];
  public formEditHoraires: FormGroup;

  ngOnChanges(changes: SimpleChanges): void {
    // console.log({ where: 'ngOnChanges', changes, coursId: changes.coursId.currentValue});
    if (changes.coursId) {
      const newCoursId = changes.coursId.currentValue;
      this.loadCours(newCoursId);
    }
  }
  loadParametres() {
    // Ce serait bien de mettre ces paramètrs dans le store
    if (this.subParametres) {
      this.subParametres.unsubscribe();
    }
    const paramsSalle = { params: { 'params': JSON.stringify(['SALLE']) } };
    const paramsProfesseur = { params: { 'params': JSON.stringify(['PROFESSEUR']) } };
    this.subParametres = Observable.forkJoin(
      this.http.get(environment.proxyUrl + '/parametrage/getParametres', paramsSalle),
      this.http.get(environment.proxyUrl + '/parametrage/getParametres', paramsProfesseur)
    ).subscribe(data => {
      console.log(data);
      const [paramsSalle, paramsProfesseur] = data;
      const parametresSalle = <Array<Object>>paramsSalle;
      const parametresProfesseurs = <Array<Object>>paramsProfesseur;
      this.parametreSalle = {};
      parametresSalle.forEach(element => {
        const cle = element['cle'];
        this.parametreSalle[cle] = element['valeur'];
      });
      this.parametreProfesseur = {};
      parametresProfesseurs.forEach(element => {
        this.parametreProfesseur[element['cle']] = element['valeur'];
      });
      // console.log({parametresSalle, parametresProfesseurs});
    });
  }

  loadCours(coursId?) {
    // this.loading = true;
    this.paramMapSub = this.route.paramMap.switchMap(params => {
      coursId = coursId ? coursId : params.get('id');
      console.log({ where: 'shared/cours/show/ngOnInit/paramMap', params, idCours: this.cours.id });
      return this.store.getState((state) => {
        const show = state.cours['show'];
        return show ? show[coursId] : null;
      })
        .do(cours => {
          if (!cours && coursId) {
            this.store.dispatch(
              CoursActions.openShow({
                http: this.http,
                cours: this.cours,
                inscription: this.inscription,
                params: [coursId, this.settings.getUserSetting('anneeScolaire')],
                errorCallback: error => {
                  console.log({ where: 'shared/cours/show/ngOnInit', error });
                  this.erreur = 'Une erreur est survenue pendant le chargement des données';
                  this.toaster.pop('error', this.erreur);
                }
              })
            );
          }
        })
        .filter(cours => !!cours);
    })
      .subscribe(cours => {
        this.cours = new CoursModel(cours);
        this.form = this.formGenerator.createFormGroup(this.cours, 'show');
        console.log('ShowcoursComponent', 'cours', this.cours);
        this.erreur = null;
        this.confMessage = `Voulez-vous vraiment supprimer le cours ${this.cours.libelle} (${this.cours.id}) ?`;
        this.initAnneeScolaireDuCours();
        // this.loading = false;
      });
  }
  ngOnInit() {
    this.loadParametres();
    this.storeSubOptions = this.store.getState(state => state.selectOptions).subscribe(state => {
      this.anneesScolaires = state.anneesScolaires;
      this.initAnneeScolaireDuCours();
    });
    this.storeSub = this.store.getState(state => state.cours).subscribe(state => {
      this.loading = state.loading;
    });
    this.initInscriptionsButtons();
    this.loadCours();
  }
  ngOnDestroy(): void {
    this.storeSub.unsubscribe();
    if (this.paramMapSub) {
      this.paramMapSub.unsubscribe();
    }
    if (this.storeSubOptions) {
      this.storeSubOptions.unsubscribe();
    }
  }
  public initAnneeScolaireDuCours() {
    if (this.anneesScolaires) {
      const anneeScolaireDucours: any = this.anneesScolaires.find(an => +an.value === +this.cours.anneeScolaire);
      this.anneeScolaireDuCoursLibelle = anneeScolaireDucours ? anneeScolaireDucours.label : this.cours.anneeScolaire;
    }
  }

  public jourDuCours(): string {
    return jourTransform(this.cours.jour);
  }
  public horaireDuCours(): string {
    if (!this.cours.horaireDebut) {
      return '';
    }
    return ((this.cours.horaireDebut) ? DateHelper.minutesToHoursMin(this.cours.horaireDebut) : '')
      + ' - '
      + ((this.cours.horaireFin) ? DateHelper.minutesToHoursMin(this.cours.horaireFin) : '');
  }
  public toDateString(madate: any) {
    return madate ? DateHelper.dateBDD2Date(madate).toLocaleDateString() : '';
  }
  coursForTransfertSelected(c) {
    console.log('coursSelected', c);
    this.coursCible = c;
  }
  onTransfert() {
    if (!this.settings.isUserRouteAllowed('/cours/edit')) {
      // utilisateur non autorisé
      return;
    }
    this.selectedEleves = [];
    console.log({ ou: 'onTransfert', searchForm: this.searchForm, cours: this.cours});
    // this.searchForm = this.formGenerator.createFormGroup(this.cours, 'search');
    // this.coursRechercheModel.isUniquementAvecPlacesDisponibles = true;
    // this.modalTransfert.Component.initForm();
    this.parametresRechercheInit = {

      isUniquementAvecPlacesDisponibles: true,
      typeCours: 2,
      discipline: this.cours.discipline.id,
      // isInscriptionNonFacturee: true, // uniquement pour tester initialisation valeur -> ne fonctionne pas sur les checkbox
    };
    this.modalTransfert.open();
  }
  selectionChanged(selection) {
    console.log({selection});
    this.selectedEleves = selection;
  }
  transferer() {
    /**
     * Valider le transfert :
        ServiceInscription.transfererEleves(this.coursReaded.id, this.selectedCoursForTransfert.id, this.eleveSelectionnesPourTransfertList.toArray(), handleTransfertEleveSuccess, this);
        remote.transfererEleves(idCoursSrc, idCoursDest,  ); */
    const idCoursSource = this.cours.id;
    const idCoursCible = this.coursCible.id;
    if (idCoursSource === idCoursCible) {
      this.toaster.pop('error', 'Vous ne pouvez pas transférer des élèves d\'un cours sur le même cours.');
      return;
    }
    console.log({ ou: 'transferer', eleves: this.selectedEleves, cours: this.cours, coursCible: this.coursCible });
    const listeIdsElevesATransferer = this.selectedEleves.map(ins => ins.eleve.id);
    if (listeIdsElevesATransferer.length === 0) {
      this.toaster.pop('error', 'Vous n\'avez sélectionné aucun élève à transférer.');
      return;
    }
    const params = [idCoursSource, idCoursCible, listeIdsElevesATransferer];
    console.log({ ou: 'transferer : /inscription/transfererElevesId', source: this.cours.id, cible: this.coursCible.id, listeIdsElevesATransferer });
    this.http.get(environment.proxyUrl + '/inscription/transfererElevesId',
      {
        params: {
          'params': JSON.stringify(params),
        }
      })
      .subscribe(data => {
        console.log(data);
        this.toaster.pop('info', 'Les élèves ont été transférés');
        this.onRefresh();
        this.modalTransfert.close();
      }, (err) => {
        console.log('Erreur lors du transfert des élèves', err);
        this.toaster.pop('error', 'Erreur lors du transfert des élèves');
      }
      );
  }

  imprimeFicheCours() {
    const service = 'impression';
    const method = 'printFicheCours';
    const params = [this.cours.id, this.settings.getUserSetting('anneeScolaire')];
    const fileNameOnDisk = 'Cours_' + this.cours.id;
    this.exportService.generePDF2(service, method, params, fileNameOnDisk);
  }

  onDeleteCours() {
    if (!this.settings.isUserRouteAllowed('/cours/delete')) {
      // utilisateur non autorisé
      return;
    }
    this.modalConfirmationDelete.buttonType = 'delete';
    this.modalConfirmationDelete.modal.open();
  }

  editCoursHoraires() {
    this.jourOptions = jourOptions;
    let hd = new Date();
    if (this.cours.horaireDebut) {
      const horaire = this.cours.horaireDebut ? +this.cours.horaireDebut : null;
      hd.setHours(Math.floor(horaire / 60));
      hd.setMinutes(horaire % 60);
    } else {
      hd.setHours(0);
      hd.setMinutes(0);
    }
    this.formEditHoraires = this.fb.group({
      id: [+this.cours.id],
      jour: [+this.cours.jour, Validators.required],
      horaireDebut: [hd, Validators.required]
    });
    // console.log({ where: 'editCoursHoraires', formEditHoraires: this.formEditHoraires });
    this.modalModifHoraires.open();
  }
  validerHoraires() {
    // console.log({ where: 'validerHoraires (btn)', modifEffectuees: this.formEditHoraires.dirty, formEditHoraires: this.formEditHoraires})
    const typeControles = this.getTypeControlChevauchement();
    const horaire: Date = this.formEditHoraires.value.horaireDebut;
    const cours = {
      id: this.cours.id,
      jour: this.formEditHoraires.value.jour,
      horaireDebut: horaire.getHours() * 60 + horaire.getMinutes(),
    }
    // console.log(cours);
    
    // TODO voir pour utiliser le store cours car sinon celui-ci n'est pas à jour
    // Cf edit.component
    this.store.dispatch(CoursActions.updateHoraires({
      http: this.http,
      model: this.cours,
      form: cours, //this.formEditHoraires,
      params: [ cours, typeControles ],
      successCallback: (data) => {
        console.log(data);
        this.modalModifHoraires.close();
        this.coursModified.emit(cours);
        this.formEditHoraires=null;
        // TODO voir ce qu'il faut faire dans ce cas
        /*this.tabsService.addTab({
          label: `Cours (${data})`,
          link: '/cours/show/' + data,
          group: 'cours',
          iconClass: 'fa fa-user',
        });
        this.router.navigate(['cours/show', data]);*/
      },
      errorCallback: (error) => {
        console.log(error);
        /*switch (error) {
          case -5: // Salle déjà utilisée
            if (this.parametreSalle['CHEV_COURS_NIV_MSG'] === 'A') {
              // Mesage d'avertissement, relancer l'enregistrement si l'utilisateur le demande
              const messageQuestion = 'La salle est occupée à l\'horaire demandé. Confirmez-vous l\'enregistrement ?';
              const confirmationButtonType = 'valid';
              const confirmationButtonLabel = 'Oui';
              const confirmationData = {
                typeControle: typeControle
                  - (coeffControleChevauchementSalle > 0 ? coeffControleChevauchementSalle : 0)
                  - (coeffControleDisponibiliteSalle > 0 ? coeffControleDisponibiliteSalle : 0), // semble être en même temps sur les contrôles côté serveur ?
              };
              this.openConfirmationGeneric(messageQuestion, confirmationButtonType, confirmationButtonLabel, confirmationData);
            }
            break;
          case -6: // Professeur et salle non disponibles
            if (this.parametreSalle['CHEV_COURS_NIV_MSG'] === 'A' || this.parametreProfesseur['CHEV_COURS_NIV_MSG'] === 'A') {
              // Mesage d'avertissement, relancer l'enregistrement si l'utilisateur le demande
              const messageQuestion = 'La salle et le professeur sont occupés à l\'horaire demandé. Confirmez-vous l\'enregistrement ?';
              const confirmationButtonType = 'valid';
              const confirmationButtonLabel = 'Oui';
              const confirmationData = {
                typeControle: typeControle
                  - (coeffControleChevauchementSalle > 0 ? coeffControleChevauchementSalle : 0)
                  - (coeffControleProfesseurOccupe > 0 ? coeffControleProfesseurOccupe : 0),
              };
              this.openConfirmationGeneric(messageQuestion, confirmationButtonType, confirmationButtonLabel, confirmationData);
            }
            break;
          case -7: // Salle non disponible pour les heures de cours
            if (this.parametreSalle['DISPO_SALLE_NIV_MSG'] === 'A') {
              // Mesage d'avertissement, relancer l'enregistrement si l'utilisateur le demande
              const messageQuestion = 'La salle n\'est pas disponible à l\'horaire demandé. Confirmez-vous l\'enregistrement ?';
              const confirmationButtonType = 'valid';
              const confirmationButtonLabel = 'Oui';
              const confirmationData = {
                typeControle: typeControle
                  - (coeffControleDisponibiliteSalle > 0 ? coeffControleDisponibiliteSalle : 0)
                  - (coeffControleChevauchementSalle > 0 ? coeffControleChevauchementSalle : 0),
              };
              this.openConfirmationGeneric(messageQuestion, confirmationButtonType, confirmationButtonLabel, confirmationData);
            }
            break;
          default: // Afficher le message bloquant
            this.toaster.pop('error', this.errorMessage.getCoursCreateMessage(error));
            break;
        }*/
      }
    }));

    /*const params = [cours, typeControles];
    this.http.get(environment.proxyUrl + '/cours/updateHoraire',
      {
        params: {
          'params': JSON.stringify(params),
        }
      })
      .subscribe(data => {
        console.log(data);
        this.toaster.pop('info', 'L\'horaire du cours a été enregistré');
        this.modalModifHoraires.close();
      }, (err) => {
        console.log('Enregistrement de l\'horaire du cours en erreur', err);
        this.toaster.pop('error', 'Erreur lors de l\'enregistrement des horaires.');
      }
      );*/
  }
  getTypeControlChevauchement(): number {
    const coeffControleChevauchementSalle = (this.parametreSalle['CHEV_COURS_NIV_MSG'] !== 'N') ? 2 : 0;
    const coeffControleDisponibiliteSalle = (this.parametreSalle['DISPO_SALLE_NIV_MSG'] !== 'N') ? 4 : 0;
    const coeffControleProfesseurOccupe = (this.parametreProfesseur['CHEV_COURS_NIV_MSG'] !== 'N') ? 1 : 0;
    return coeffControleChevauchementSalle + coeffControleDisponibiliteSalle + coeffControleProfesseurOccupe;
  }
  editCours() {
    this.tabsService.addTab({
      label: `Cours (${this.cours.id})`,
      link: '/cours/edit/' + this.cours.id,
      group: 'cours',
      iconClass: 'fa fa-edit',
    });
    this.router.navigate(['/cours/edit', this.cours.id]);
  }

  copyCours() {
    if (!this.settings.isUserRouteAllowed('/cours/create')) {
      // utilisateur non autorisé
      return;
    }
    this.router.navigate(['cours/copy', this.cours.id]);
  }

  deleteCours() {
    if (!this.settings.isUserRouteAllowed('/cours/delete')) {
      // utilisateur non autorisé
      return;
    }
    this.store.dispatch(
      CoursActions.delete({
        http: this.http,
        model: this.cours,
        params: [{ id: this.cours.id }],
        successCallback: (data) => {
          this.toaster.pop('info', 'Cours ' + this.cours.id + ' supprimé.');
          this.tabsService.removeTab({ link: '/cours/show/' + this.cours.id, group: 'cours' });
          this.tabsService.removeTab({ link: '/cours/edit/' + this.cours.id, group: 'cours' });
          this.router.navigate(['/cours']);
          this.modalConfirmationDelete.modal.close();
        },
        errorCallback: (error) => {
          console.log('deleteCours.errorCallback', error);
          this.toaster.pop('error', this.errorMessages.getCoursCreateMessage(error));
          this.modalConfirmationDelete.modal.close();
        },
      })
    );
  }

  clearCacheCours(idcours) {
    // Vidage cache pour forcer rechargement
    this.store.dispatch(
      CoursActions.clear({
        id: idcours,
        errorCallback: (err) => {
          console.log('CoursSearchComponent', 'clear error', err);
          this.toaster.pop('error', 'Erreur lors du vidage du cours');
        }
      })
    );
  }

  onRefresh() { /**data: TableEvent */
    const idCours = this.cours.id;
    this.clearCacheCours(idCours);
    this.router.navigate(['/cours/']);

    this.router.navigate(['/cours/show', idCours]);

    this.tabsService.addTab({
      label: `Cours (${this.cours.id})`,
      link: '/cours/show/' + this.cours.id,
      group: 'cours',
      iconClass: 'fa fa-user',
    });
  }
  // ####################
  // Tableau inscriptions
  // ####################
  initInscriptionsButtons() {
    if (this.settings.isUserRouteAllowed('/cours/edit')) {
      this.inscriptionsButtons.push('transfer');
    }
    if (this.settings.isUserRouteAllowed('/eleve/show')) {
      this.inscriptionsButtons.push('student');
    }
    if (this.settings.isUserRouteAllowed('/famille/show')) {
      this.inscriptionsButtons.push('family');
    }
  }
  onTransfertVersCours(inscription) {
    console.log({ ou: 'transfertVersCours', inscription, libEleve: inscription.row.eleveLibelle, modal: this.modalConfirmationTransfert });
    const libelleEleve = inscription.row.eleveLibelle ? inscription.row.eleveLibelle : '';
    this.modalConfirmationTransfert.data = inscription;
    this.modalConfirmationTransfert.message = `Confirmez-vous le transfert de l\élève ${libelleEleve} vers un cours individuel ?`;
    // this.modalConfirmationTransfert.buttonType = 'valide';
    this.modalConfirmationTransfert.modal.open();
  }
  confirmationTransfert(data) {
    console.log(data);
    const idInscription = data.data.row.id;
    console.log(idInscription);
    const params = [idInscription];
    console.log({ ou: 'Transfert élève vers cours individuel' });
    this.http.get(environment.proxyUrl + '/inscription/transfererEleveVersCoursIndividuel',
      {
        params: {
          'params': JSON.stringify(params),
        }
      })
      .subscribe(data => {
        console.log(data);
        this.toaster.pop('info', 'L\'élève a été transféré');
        this.onRefresh();
        this.modalConfirmationTransfert.modal.close();
      }, (err) => {
        console.log('Erreur lors du transfert de l\'élève', err);
        this.toaster.pop('error', 'Erreur lors du transfert de l\'élève');
      }
      );
    // transfererEleveVersCoursIndividuel($idInscription)
  }
  onShowEleve(event) {
    console.log({ ou: 'onShowEleve', event, idEleve: event.row.eleve.id, eleve: event.row.eleveLibelle });
    const idEleve = event && event.row && event.row.eleve && event.row.eleve.id ? event.row.eleve.id : null;
    const libelleEleve = event && event.row && event.row.eleveLibelle ? event.row.eleveLibelle : '';
    if (idEleve) {
      this.router.navigate(['/eleve/show', idEleve]);
      this.tabsService.addTab({
        label: `${libelleEleve} (${idEleve})`,
        link: '/eleve/show/' + idEleve,
        group: 'eleve',
        iconClass: 'fa fa-user'
      });
    }
  }
  onShowFamily(event) {
    console.log({ ou: 'onShowFamily', event, idFamille: event.row.eleve.famille.id, nomFamille: event.row.eleve.famille.nom });
    const idFamille = event && event.row && event.row.eleve && event.row.eleve.famille && event.row.eleve.famille.id ? event.row.eleve.famille.id : null;
    if (idFamille) {
      this.router.navigate(['/famille/show', idFamille]);
      this.tabsService.addTab({
        label: ` (${idFamille})`,
        link: '/famille/show/' + idFamille,
        group: 'famille',
        iconClass: 'fa fa-user'
      });
    }
  }
}



// WEBPACK FOOTER //
// /builds/eveasoft/lea/lea-front/src/app/shared/cours/show/show.component.ts